module.exports = __webpack_public_path__ + "img/bannerPc-2-1.85ad17e7.png";